import { render, staticRenderFns } from "./performanceSetups.vue?vue&type=template&id=5b297380"
import script from "./performanceSetups.vue?vue&type=script&lang=js"
export * from "./performanceSetups.vue?vue&type=script&lang=js"
import style0 from "./performanceSetups.vue?vue&type=style&index=0&id=5b297380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports